import { OrganizationState } from '../enums/organization-state.enum';

export class IUpdateOrganizationState {
    id: string;
    state: OrganizationState;
}
